export default __webpack_public_path__ + "static/media/IkonHerfaarDuLetsikringer.d58d25ce.svg";